import React, { FC } from "react";
import { Card, Box, CardContent, CardMedia } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import CustomButton from "./common/CustomBtn";

interface Partner {
  logo: string;
  path: string;
}

interface CardProps {
  img: string;
  title: string;
  desc: string;
  path: string;
  partners: Partner[];
}
const ProductCard: FC<CardProps> = ({ img, title, desc, path, partners }) => {
  const navigate = useNavigate();

  return (
    <Card
      sx={{
        display: "flex",
        flexWrap: { xs: "wrap", lg: "nowrap" },
      }}
      className="relative overflow-hidden group hover:shadow-md"
    >
      <div className="relative w-full semi:w-[251px] min-h-[200px] semi:h-auto">
        <CardMedia
          component="div"
          sx={{
            width: { xs: "100%", lg: 251 },
            height: "100%",
          }}
          className="w-full h-full bg-[#fafafa]"
          style={{
            backgroundImage: `url(${img})`,
            backgroundSize: "revert-layer",
            backgroundPosition: "center",
          }}
        />

        <div className="absolute inset-0 z-10 transition-all duration-300 bg-white bg-opacity-0 group-hover:bg-opacity-40" />

        <div className="absolute inset-0 z-20 flex items-center justify-center transition-opacity duration-300 opacity-0 group-hover:opacity-100">
          <CustomButton
            color="primary"
            onClick={() => {
              window.scrollTo(0, 0);
              navigate(`${path}`, {
                replace: false,
                state: { preserveScroll: false },
              });
            }}
          >
            See More
          </CustomButton>
        </div>
      </div>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          //   padding: "20px",
          maxWidth: "350px",
          width: "100%",
        }}
      >
        <CardContent>
          <h4 className="mb-2 text-sm font-bold group-hover:text-primary">
            {title}
          </h4>
          <p className="text-[14px] text-greyText mb-4">{desc}</p>

          <div className="flex flex-wrap items-center gap-7">
            {partners.map((partner, idx) => (
              <Link
                key={idx}
                target="_blank"
                to={partner.path}
                className="relative transition-transform duration-300 transform w-14 hover:scale-105"
              >
                <img
                  src={partner.logo}
                  alt={`partner-${idx}`}
                  className="object-contain w-full h-full"
                />
              </Link>
            ))}
          </div>
        </CardContent>
      </Box>
    </Card>
  );
};

export default ProductCard;
